import { IAsyncData } from "@/domains/async/AsyncData";
import styled from "@emotion/styled";
import { inflect } from "inflection";
import { isUndefined } from "lodash-es";

interface Props {
  sizeData: IAsyncData<number>;
  itemTypeName?: string;
  description?: string;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export function CollectionItemSubtitle({ sizeData, itemTypeName, description }: Props) {
  return (
    <Wrapper hasLoadedData={!isUndefined(sizeData.data)}>
      {getCollectionItemSubtitle(sizeData, itemTypeName, description)}
    </Wrapper>
  );
}

const Wrapper = styled.div<{ hasLoadedData: boolean }>(({ theme, hasLoadedData }) => ({
  color: theme.colors.text.secondary,
  fontSize: theme.fontSizes["text-s"],
  lineHeight: theme.lineHeights["text-xs"],
  opacity: hasLoadedData ? 1 : 0,
  transition: "opacity 0.12s ease-in-out",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  width: "100%",
}));

export const getCollectionItemSubtitle = (
  sizeData: IAsyncData<number>,
  itemTypeName?: string,
  description?: string
) => {
  if (isUndefined(sizeData.data)) {
    /**
     * We return a whitespace character to ensure that the subtitle is not collapsed.
     * (We should improve this in the future)
     */
    return "\u00A0";
  }

  if (sizeData.data === 0) {
    if (description) {
      return description;
    }

    return `No ${inflect(itemTypeName ?? "item", 0)}`;
  }

  const countText = `${sizeData.data} ${inflect(itemTypeName ?? "item", sizeData.data)}`;

  if (!description) {
    return countText;
  }

  return `${countText} • ${description}`;
};
